
import { createRoot } from 'react-dom/client';
import { InstUISettingsProvider } from '@instructure/emotion';
import { instuiTheme } from '@/bootstrap';

export function mountApp(appComponent: JSX.Element) {
    document.addEventListener('DOMContentLoaded', async () => {
        const hostEl = document.createElement('div');
        hostEl.setAttribute('id', 'root');
        document.body.appendChild(hostEl);
        createRoot(hostEl).render(
            <InstUISettingsProvider theme={instuiTheme}>
                {appComponent}
            </InstUISettingsProvider>
        );
    })
}
